<template>
  <!-- eslint-disable vue/no-parsing-error  -->
  <div>
    <div class="container">
      <div class="columns is-centered">
        <div class="b-portlet" style="width: 100%">
          <div class="b-portlet-header has-text-centered">
            <h1 class="is-size-5 has-text-weight-bold">
              {{ $t('title.onlineInternalAudit') }}
              {{ $t('title.servicePackage') }}
            </h1>
          </div>
          <div class="b-portlet-body">
            <div class="columns">
              <div class="column is-7">
                <div class="b-portlet" style="margin-bottom: 40px">
                  <div class="b-portlet-header">
                    <div class="columns is-vcentered">
                      <div class="column is-8">
                        <h3 class="is-size-5 has-text-weight-bold">
                          {{ $t('title.payingInfo') }}
                        </h3>
                      </div>
                      <!-- <div class="column is-4">
                        <img
                          class="is-pulled-right"
                          src="../../assets/iyzico.png"
                        />
                      </div> -->
                    </div>
                  </div>
                  <div class="b-porlet-body">
                    <CreditCard v-model="creditCard"></CreditCard>
                  </div>
                </div>
                <div class="b-portlet" style="margin-bottom: 40px; padding: 20px">
                  <div class="b-portlet-header">
                    <h3 class="is-size-5 has-text-weight-bold">
                      {{ $t('title.billingInfo') }}
                    </h3>
                  </div>
                  <div class="b-portlet-body">
                    <form v-on:submit.prevent="onSubmit()">
                      <div class="field field-body">
                        <b-field
                          :type="{ 'is-danger': errors.has('firstName') }"
                          :message="errors.first('firstName')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="user"
                            :placeholder="$t('validation.attributes.firstName')"
                            v-model="billing.firstname"
                            name="firstName"
                            v-validate="'required'"
                          />
                        </b-field>
                        <b-field
                          :type="{ 'is-danger': errors.has('lastName') }"
                          :message="errors.first('lastName')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="user"
                            :placeholder="$t('validation.attributes.lastName')"
                            v-model="billing.lastname"
                            name="lastName"
                            v-validate="'required'"
                          />
                        </b-field>
                      </div>
                      <b-field>
                        <div class="block">
                          <b-radio
                            v-model="billingType"
                            name="bilingType"
                            native-value="personal"
                            @input="changeBillingType()"
                            >{{ $t('title.personal') }}</b-radio
                          >
                          <b-radio
                            v-model="billingType"
                            name="bilingType"
                            native-value="commercial"
                            @input="changeBillingType()"
                            >{{ $t('title.commercial') }}</b-radio
                          >
                        </div>
                      </b-field>
                      <b-field
                        v-if="billingType === 'personal'"
                        :type="{ 'is-danger': errors.has('identityNo') }"
                        :message="errors.first('identityNo')"
                      >
                        <b-input
                          icon-pack="fas"
                          icon="id-card"
                          :placeholder="$t('validation.attributes.identityNo')"
                          v-model="billing.identityNo"
                          name="identityNo"
                          v-validate="billingType === 'personal' ? 'required|min:11|max:11' : ''"
                        />
                      </b-field>
                      <div v-if="billingType === 'commercial'" style="padding-bottom: 15px">
                        <b-field
                          :type="{ 'is-danger': errors.has('companyName') }"
                          :message="errors.first('companyName')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="building"
                            :placeholder="$t('validation.attributes.companyName')"
                            v-model="billing.companyName"
                            name="companyName"
                            v-validate="billingType === 'commercial' ? 'required' : ''"
                          />
                        </b-field>

                        <div class="field field-body">
                          <b-field
                            :type="{ 'is-danger': errors.has('taxNo') }"
                            :message="errors.first('taxNo')"
                          >
                            <b-input
                              icon-pack="fas"
                              icon="file-invoice"
                              :placeholder="$t('validation.attributes.taxNo')"
                              v-model="billing.taxNo"
                              name="taxNo"
                              v-validate="billingType === 'commercial' ? 'required' : ''"
                            />
                          </b-field>
                          <b-field
                            :type="{
                              'is-danger': errors.has('taxAdministration')
                            }"
                            :message="errors.first('taxAdministration')"
                          >
                            <b-input
                              icon-pack="fas"
                              icon="warehouse"
                              :placeholder="$t('validation.attributes.taxAdministration')"
                              v-model="billing.taxAdministration"
                              name="taxAdministration"
                              v-validate="billingType === 'commercial' ? 'required' : ''"
                            />
                          </b-field>
                        </div>
                      </div>

                      <b-field
                        :type="{ 'is-danger': errors.has('address') }"
                        :message="errors.first('address')"
                      >
                        <b-input
                          rows="2"
                          type="textarea"
                          v-model="billing.address"
                          name="address"
                          :placeholder="$t('validation.attributes.address')"
                          v-validate="'required'"
                        ></b-input>
                      </b-field>
                      <div class="field field-body">
                        <b-field
                          :type="{ 'is-danger': errors.has('city') }"
                          :message="errors.first('city')"
                        >
                          <b-select
                            expanded
                            icon-pack="fas"
                            icon="city"
                            v-model="billing.city"
                            name="city"
                            :placeholder="$t('validation.attributes.city')"
                            v-validate="'required'"
                          >
                            <option v-for="option in cities" :value="option.name" :key="option.id">
                              {{ option.name }}
                            </option>
                          </b-select>
                        </b-field>
                        <b-field
                          :type="{ 'is-danger': errors.has('district') }"
                          :message="errors.first('district')"
                        >
                          <b-input
                            icon-pack="fas"
                            icon="building"
                            :placeholder="$t('validation.attributes.district')"
                            v-model="billing.district"
                            name="district"
                            v-validate="'required'"
                          />
                        </b-field>
                      </div>
                      <b-field
                        :type="{ 'is-danger': errors.has('gsmNumber') }"
                        :message="errors.first('gsmNumber')"
                      >
                        <b-input
                          icon-pack="fas"
                          icon="mobile-alt"
                          :placeholder="$t('validation.attributes.gsmNumber')"
                          v-model="billing.gsmNumber"
                          name="gsmNumber"
                          v-validate="'required'"
                        />
                      </b-field>
                      <b-field
                        class="field"
                        :type="{ 'is-danger': errors.has('email') }"
                        :message="errors.first('email')"
                      >
                        <b-input
                          icon-pack="fas"
                          icon="envelope"
                          :placeholder="$t('validation.attributes.email')"
                          v-model="billing.email"
                          name="email"
                          v-validate="'required|email'"
                        />
                      </b-field>
                    </form>
                  </div>
                </div>
              </div>
              <div class="column is-5">
                <div class="b-portlet">
                  <div class="b-portlet-header">
                    <h3 class="is-size-5 has-text-weight-bold">
                      {{ $t('title.amount') }}
                    </h3>
                  </div>
                  <div class="b-portlet-body">
                    <ul>
                      <li>
                        1 x {{ $t('title.onlineInternalAudit') }}
                        {{ $t('title.servicePackage') }}
                        <span class="is-pulled-right has-text-weight-bold "
                          >{{ $t('title.packageAmount') }} {{ $t('title.packageCurrency') }}
                          <span class="is-size-7">+ KDV</span></span
                        >
                      </li>
                      <li v-if="discount">
                        {{ discount.code }} (%{{ discount.value }})
                        <span class="is-pulled-right has-text-weight-bold"
                          >- {{ discount.amount }} {{ $t('title.packageCurrency') }}</span
                        >
                      </li>
                      <li v-if="discount">
                        <b>{{ $t('title.total') }}</b>
                        <span class="is-pulled-right has-text-weight-bold"
                          >{{ price }} {{ $t('title.packageCurrency') }}</span
                        >
                      </li>
                    </ul>
                    <hr class="navbar-divider" style="margin:20px 0 20px 0;" />
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <b-input
                          icon-pack="fas"
                          icon="money-check-alt"
                          :placeholder="$t('validation.attributes.discountCode')"
                          v-model="discountCode"
                          name="discountCode"
                        />
                        <span
                          v-if="invalidDiscountCode"
                          class="has-text-danger"
                          style="padding: 5px"
                          >{{ $t('description.invalidDiscountCode') }}</span
                        >
                      </div>
                      <div class="control">
                        <a class="button is-dark" @click="checkDiscount()">{{
                          $t('button.apply')
                        }}</a>
                      </div>
                    </div>
                    <hr class="navbar-divider" style="margin:20px 0 20px 0;" />
                    <b-field
                      style="padding-top: 10px"
                      :type="{ 'is-danger': errors.has('readInformationForm') }"
                      :message="errors.first('readInformationForm')"
                    >
                      <b-checkbox
                        name="readInformationForm"
                        v-validate="'required:true'"
                        v-model="readInformationForm"
                      >
                        <a @click="openPaymentInformationModal()">{{
                          $t('description.informationFormLink')
                        }}</a>
                        {{ $t('description.readAndAgree') }}.
                      </b-checkbox>
                    </b-field>
                    <b-field
                      :type="{ 'is-danger': errors.has('readSalesAgreement') }"
                      :message="errors.first('readSalesAgreement')"
                    >
                      <b-checkbox
                        name="readSalesAgreement"
                        v-validate="'required:true'"
                        v-model="readSalesAgreement"
                      >
                        <a @click="openPaymentSalesAgrementModal()">{{
                          $t('description.salesAgreementLink')
                        }}</a>
                        {{ $t('description.readAndAgree') }}.
                      </b-checkbox>
                    </b-field>
                  </div>
                  <div class="b-portlet-footer" style="margin-bottom: 20px">
                    <div class="field is-grouped is-pulled-right">
                      <div class="control">
                        <button class="button is-primary" @click="startPayment">
                          {{ $t('button.pay') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered" style="padding-top: 10px">
        <img class="" src="../../assets/footer-payments.png" />
      </div>
    </div>
    <ContentFooter style="margin-top: 25px" />
  </div>
</template>
<script>
import ApiService from '../../_api/api.service'
import CreditCard from '@/components/CreditCard.vue'
import PaymentAgreement from './PaymentAgreement.vue'
import ContentFooter from '../../layouts/dashboard/ContentFooter.vue'
import Payment3D from './Payment3D.vue'

export default {
  components: { CreditCard, ContentFooter },
  data () {
    return {
      billing: {},
      cities: [],
      creditCard: {},
      discountCode: null,
      invalidDiscountCode: false,
      billingType: 'personal',
      packagePrice: parseFloat(this.$t('title.packageAmount')),
      price: parseFloat(this.$t('title.packageAmount')),
      ipAddress: null,
      readInformationForm: false,
      readSalesAgreement: false,
      discount: null
    }
  },
  mounted () {
    this.loadSelects()
    ApiService.query('https://ipapi.co/json/', {
      crossDomain: true
    }).then(data => {
      this.ipAddress = data.ip
    })
  },
  methods: {
    changeBillingType () {
      this.billing.identityNo = null
      this.billing.taxAdministration = null
      this.billing.companyName = null
      this.billing.taxNo = null
    },
    loadSelects () {
      ApiService.query('/select/cities').then(data => {
        this.cities = data
      })
    },
    checkDiscount () {
      ApiService.post('/discount/verify', {
        discountCode: this.discountCode
      }).then(data => {
        if (data.isValid === true) {
          this.invalidDiscountCode = false
          this.discount = {
            code: this.discountCode,
            value: data.value,
            amount: this.packagePrice * (data.value / 100)
          }
          this.price = this.packagePrice - this.discount.amount
        } else {
          this.discountCode = null
          this.invalidDiscountCode = true
          this.discount = null
          this.price = parseFloat(this.$t('title.packageAmount'))
        }
      })
    },
    startPayment () {
      this.$validator.validateAll().then(result => {
        if (result) {
          ApiService.post('/payment/start', {
            discountCode: this.discountCode,
            invoiceInfo: this.billing,
            paymentInfo: this.creditCard,
            ipAddress: this.ipAddress,
            readInformationForm: this.readInformationForm,
            readSalesAgreement: this.readSalesAgreement
          }).then(({ htmlContent, paymentId }) => {
            if (htmlContent) {
              this.$buefy.modal.open({
                parent: this,
                props: { htmlContent, paymentId },
                component: Payment3D
              })
            }
          })
        }
      })
    },
    openPaymentInformationModal () {
      ApiService.post('/payment/agreement', {
        discountCode: this.discount ? this.discount.code : null,
        invoiceInfo: this.billing,
        formName: 'PaymentInformation'
      }).then(data => {
        if (data) {
          this.$buefy.modal.open({
            parent: this,
            props: { htmlContent: data, name: 'PaymentInformation' },
            component: PaymentAgreement,
            events: {
              saved: () => {
                this.readInformationForm = true
              }
            }
          })
        }
      })
    },
    openPaymentSalesAgrementModal () {
      ApiService.post('/payment/agreement', {
        discountCode: this.discount ? this.discount.code : null,
        invoiceInfo: this.billing,
        formName: 'SalesAgreement'
      }).then(data => {
        if (data) {
          this.$buefy.modal.open({
            parent: this,
            props: { htmlContent: data, name: 'SalesAgreement' },
            component: PaymentAgreement,
            events: {
              saved: () => {
                this.readSalesAgreement = true
              }
            }
          })
        }
      })
    }
  }
}
</script>
